import {
    CLUBS_PATCH_FAILURE,
    CLUBS_PATCH_REQUEST,
    CLUBS_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const clubPatchReducer = (state = initialState, action) => {
    const {type, club} = action;
    switch (type) {
        case CLUBS_PATCH_SUCCESS: {return {
            ...initialState,
            club,
        }}

        case CLUBS_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case CLUBS_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
